var cifBw = ["301 201", "<g fill='none'><path fill='#75AADB' d='M.5.5h300v200H.5z'/><path fill='#FFF' d='M.5 75.5h300v50H.5z'/><path fill='#000' d='M.5 83.833h300v33.333H.5z'/></g>"];

export { cifBw };

